import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { NumericUpDownComponent } from 'src/app/ui/molecules/numeric-up-down/numeric-up-down.component';

@Component({
  selector: 'app-step3',
  standalone: true,
  imports: [
    TranslatePipe,
    NumericUpDownComponent
  ],
  templateUrl: './step3.component.html',
  styleUrl: './step3.component.scss'
})
export class Step3Component {
  @Input({required: true}) quotation: Quotation;
}
